export const containerInstance = 'smooth-dnd-container-instance';

export const defaultGroupName = '@@smooth-dnd-default-group@@';
export const wrapperClass = 'smooth-dnd-draggable-wrapper';
export const defaultGrabHandleClass = 'smooth-dnd-default-grap-handle';
export const animationClass = 'animated';
export const translationValue = '__smooth_dnd_draggable_translation_value';
export const visibilityValue = '__smooth_dnd_draggable_visibility_value';
export const ghostClass = 'smooth-dnd-ghost';

export const containerClass = 'smooth-dnd-container';

export const extraSizeForInsertion = 'smooth-dnd-extra-size-for-insertion';
export const stretcherElementClass = 'smooth-dnd-stretcher-element';
export const stretcherElementInstance = 'smooth-dnd-stretcher-instance';

export const isDraggableDetached = 'smoth-dnd-is-draggable-detached';

export const disbaleTouchActions = 'smooth-dnd-disable-touch-action';
export const noUserSelectClass = 'smooth-dnd-no-user-select';

export const preventAutoScrollClass = 'smooth-dnd-prevent-auto-scroll-class';

export const dropPlaceholderDefaultClass = 'smooth-dnd-drop-preview-default-class';
export const dropPlaceholderInnerClass = 'smooth-dnd-drop-preview-inner-class';
export const dropPlaceholderWrapperClass = 'smooth-dnd-drop-preview-constant-class'
export const dropPlaceholderFlexContainerClass = 'smooth-dnd-drop-preview-flex-container-class'
